module.exports = __webpack_public_path__ + "img/phone.478de68e.png";